import { Patient } from "../../types";
import { ENDPOINTS, getFullUrl } from "./config";
import { UpdatePatientVitalsDTO } from "./types";
// import { AddPatientRequest } from "./types";

export class PatientService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }

  static async getPatientDetails(patientId: string) {
    try {
      const url = new URL (getFullUrl(ENDPOINTS.PATIENT.GETPATIENTDETAILS));

      url.searchParams.append("patientId", patientId);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      console.log("details check from service", response)
      // Handle unauthorized response
      if (response.status === 401) {
        return {
          success: "invalid",
          message: "Session expired. Please log in again.",
        };
      }

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async addNewPatient(patientData: FormData) {
    try {
      const response = await fetch(getFullUrl(ENDPOINTS.PATIENT.ADD), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: patientData,
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async updatePatient(patientId: string, updatedData: Partial<Patient>) {
    try {
      const hasFile = updatedData.profileImage instanceof File;
      const isMultipart = hasFile;
      let body: BodyInit;
      let headers: HeadersInit = {
        Authorization: `Bearer ${this.getToken()}`,
      };

      if (isMultipart) {
        const formData = new FormData();
        Object.entries(updatedData).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            formData.append(key, value);
          }
        });
        body = formData;
        // Remove Content-Type header so browser sets it automatically
      } else {
        headers["Content-Type"] = "application/json";
        body = JSON.stringify(updatedData);
      }

      const response = await fetch(
        getFullUrl(ENDPOINTS.PATIENT.UPDATE.replace(":patientId", patientId)),
        {
          method: "PATCH",
          headers,
          body,
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Update failed",
      };
    }
  }

  static async deletePatient(patientId: string) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.PATIENT.DELETE
      )}?id=${patientId}&role=Patient`;

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Delete failed",
      };
    }
  }

  static async DeletePatientImage(patientId: string) {
    try {
      const response = await fetch(
        getFullUrl(
          ENDPOINTS.PATIENT.DELETEPROFILEIMAGE.replace(":patientId", patientId)
        ),
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to delete patient image. Status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to delete patient image",
      };
    }
  }

  static async sendOTP(number: string) {
    try {
      const response = await fetch(getFullUrl(ENDPOINTS.PATIENT.SENDOTP), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({
          mobileNumber: number,
        }),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async verifyOTP(number: string, otp: string) {
    try {
      const response = await fetch(getFullUrl(ENDPOINTS.PATIENT.VERIFYOTP), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({
          mobileNumber: number,
          otp: otp,
        }),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async getPatients({
  page = 1,
  pageSize = 10,
  gender,
  status,
  clinicId,
  medicalCampId,
  searchText,
}: {
  page?: number;
  pageSize?: number;
  gender: string | null;
  status: string | null;
  clinicId: string;
  medicalCampId: string;
  searchText: string;
}) {
  try {
    const params = new URLSearchParams();

    params.append("page", page.toString());
    params.append("pageSize", pageSize.toString());

    if (gender) params.append("gender", gender);
    if (status) params.append("status", status);
    if (clinicId) params.append("clinicId", clinicId);
    if (medicalCampId) params.append("medicalCampId", medicalCampId);
    if (searchText) params.append("name", searchText);

    const url = `${getFullUrl(ENDPOINTS.PATIENT.GETLIST)}?${params.toString()}`;

    const token = this.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return {
      success: data.success,
      message: data.message,
      data: {
        dataList: data.data?.dataList || [],
        totalItemsCount: data.data?.totalItemsCount || 0,
        totalPages: data.data?.totalPages || 1,
        currentPage: data.data?.currentPage || page,
      },
    };
  } catch (error) {
    return {
      success: false,
      message:
        error instanceof Error ? error.message : "Failed to fetch patients",
    };
  }
}

  static async verifyPatientByMobileNumber(mobileNumber: string) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.PATIENT.VERITYPATIENTBYMOBILE
      )}?mobileNum=${mobileNumber}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      return await response.json();
    } catch (error) {
      return {
        success: "invalid",
        message: error instanceof Error ? error.message : "Patient not found",
      };
    }
  }

  static async getPatientVitals(patientId: string, appointmentId: string) {
    try {
      //const url =new URL(`http://localhost:3001/patientservice/patient/vitals/fetch/${patientId}`)

      //const url = `${getFullUrl(ENDPOINTS.PATIENT.GETVITALS)}?patientId=${encodeURIComponent(patientId)}&appointmentId=${encodeURIComponent(appointmentId)}`;
      let url = `${getFullUrl(
        ENDPOINTS.PATIENT.GETVITALS
      )}?patientId=${encodeURIComponent(patientId)}`;

      // Append appointmentId only if it's not null or undefined
      if (appointmentId) {
        url += `&appointmentId=${encodeURIComponent(appointmentId)}`;
      }
      console.log(url);
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Cannot fetch details",
      };
    }
  }

  static async addPatientVitals(vitals: any) {
    try {
      const response = await fetch(getFullUrl(ENDPOINTS.PATIENT.ADDVITALS), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: vitals,
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to add vitals",
      };
    }
  }

  static async getPatientHealthRecords(patientId: string) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.PATIENT.GETHEALTHRECORD.replace(":patientId", patientId)
      )}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async addPatientHealthRecord(patientId: string, healthRecord: any) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.PATIENT.ADDHEALTHRECORD.replace(":patientId", patientId)
      )}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(healthRecord),
      });
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async updatePatientHealthRecord(recordId: string, healthRecord: any) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.PATIENT.UPDATEHEALTHRECORD.replace(":recordId", recordId)
      )}`;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(healthRecord),
      });
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async deletePatientHealthRecord(recordId: string) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.PATIENT.DELETEHEALTHRECORD.replace(":recordId", recordId)
      )}`;

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async getPatientAvailability(patientId: string) {
    try {
      // const url = ` http://localhost:3003/appointmentservice/patient/availability/${patientId}`;
      const url = `${getFullUrl(
        ENDPOINTS.PATIENT.GETAVAILABILITY.replace(":patientId", patientId)
      )}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Login failed",
      };
    }
  }

  static async getPatientHistoryForAppointment(
    patientId: string,
    date?: string,
    appointmentId?: string,
    doctorId?: string
  ) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.APPOINTMENT.GETPATIENTAPPOINTMENTHISTORY
      )}?patientId=${encodeURIComponent(patientId)}${
        date ? `&date=${encodeURIComponent(date)}` : ""
      }${
        appointmentId
          ? `&appointmentId=${encodeURIComponent(appointmentId)}`
          : ``
      }${doctorId ? `&doctorId=${encodeURIComponent(doctorId)}` : ``}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      const data: any = await response.json();
      return data;
    } catch (error: any) {
      return {
        success: false,
        message: error.message,
      };
    }
  }

  static async addNewPatientFamily(PatientFamilyData: FormData | object) {
    try {
      const isFormData = PatientFamilyData instanceof FormData;
      
      const response = await fetch(
        `${getFullUrl(ENDPOINTS.PATIENT.ADDFAMILYMEMBER)}`,
        {
          method: "POST",
          headers: isFormData
            ? { Authorization: `Bearer ${this.getToken()}` } // No "Content-Type" for FormData
            : {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.getToken()}`,
              },
          body: isFormData
            ? PatientFamilyData
            : JSON.stringify(PatientFamilyData),
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Request failed",
      };
    }
  }

  static async addPatientVitalsV2(vitals: AddPatientVitalsDTO) {
    try {
      const response = await fetch(getFullUrl(ENDPOINTS.PATIENT_V2.ADD_VITALS), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(vitals),
      });

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to add vitals",
      };
    }
  }

  static async updatePatientVitalsV2(vitals: UpdatePatientVitalsDTO) {
    try {
      const response = await fetch(getFullUrl(ENDPOINTS.PATIENT_V2.UPDATE_VITALS), {
        method: "PUT", // User said POST for update too
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(vitals),
      });

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to update vitals",
      };
    }
  }

  static async addPrescription(formData: FormData) {
    try {
      const response = await fetch(getFullUrl(ENDPOINTS.PATIENT_V2.ADD_PRESCRIPTION), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: formData,
      });

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to add prescription",
      };
    }
  }

  static async deletePrescription(id: string) {
    try {
      const response = await fetch(
        getFullUrl(ENDPOINTS.PATIENT_V2.DELETE_PRESCRIPTION.replace(":id", id)),
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to delete prescription",
      };
    }
  }
}
